import { Options } from '../../types';

export const getPopoverTextByPeriod = (
  options: Options,
  selectName: string,
  period: string | number,
  t: (key: string) => string
) => {
  const baseKeyTranslation = 'web.responsiblegambling.gamingactivity.form';
  const dataPeriod = options.period;
  const periodOption = dataPeriod.find((option) => option.value === period);

  if (!periodOption) {
    return [];
  }

  const periodKey = periodOption.value === 86400 ? '24hours' : 'week';
  const selectNameKey = selectName === 'limit' ? 'amount' : 'sessionduration';

  return [
    t(`${baseKeyTranslation}.${selectNameKey}.hint.description`),
    t(`${baseKeyTranslation}.${selectNameKey}.hint.${periodKey}`)
  ];
};
